import React, { useState } from 'react';
import '../css/bg.css';
import image from '../images/contact.jpg';

export default function Contact() {
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbysZuJH76q33D7gmjRUwRqN3mqpGHGhYWYcT3SUsFi1XKKF9hOcE3-OOzPsTLvWxJZs/exec"; // paste yours

  const [formData, setFormData] = useState({
    name: "", email: "", subject: "", message: ""
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors", // Required for Apps Script
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      // no-cors means we can't read the response, but if no error thrown it worked
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus("error");
    }
  };


  return (
    <div className="bg-light pb-5">
      {/* ── Hero Section ─────────────────────────── */}
      <div
        className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
        style={{
          width: '100%',
          height: '45vh',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          marginTop: '-1px'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(180deg, rgba(15,23,42,0.85) 0%, rgba(15,23,42,0.6) 100%)',
            zIndex: 1
          }}
        />
        <div className="container position-relative px-4 text-center" style={{ zIndex: 2 }}>
          <p className="section-label animate-fade-up text-info mb-3">Get In Touch</p>
          <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
            CONTACT <span className="text-info">US</span>
          </h1>
          <p className="animate-fade-up delay-2 text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px', fontSize: '1.1rem' }}>
            We're here to help you move to the next level. Let's start a conversation.
          </p>
        </div>
      </div>

      <div className="container mt-n5 position-relative" style={{ marginTop: '-50px' }}>
        <div className="row g-4">

          {/* ── Contact Form ────────────────────────── */}
          <div className="col-lg-8">
            <div className="card border-0 shadow-lg rounded-4 p-4 p-md-5" style={{ background: 'var(--ftb-bg-card)', transition: 'var(--transition)' }}>
              <h2 className="fw-bold mb-4" style={{ color: 'var(--ftb-text)' }}>Send us a Message</h2>


              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Full Name</label>
                    <input type="text" name="name" className="form-control rounded-3 p-3 bg-light border-0"
                      placeholder="John Doe" required value={formData.name} onChange={handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Email Address</label>
                    <input type="email" name="email" className="form-control rounded-3 p-3 bg-light border-0"
                      placeholder="john@example.com" required value={formData.email} onChange={handleChange} />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-semibold">Subject</label>
                    <input type="text" name="subject" className="form-control rounded-3 p-3 bg-light border-0"
                      placeholder="Project Inquiry" required value={formData.subject} onChange={handleChange} />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-semibold">Message</label>
                    <textarea name="message" className="form-control rounded-3 p-3 bg-light border-0"
                      rows="5" placeholder="How can we help you?" required
                      value={formData.message} onChange={handleChange} />
                  </div>
                  <div className="col-12 pt-2">
                    <button type="submit" disabled={status === "sending"}
                      className="btn btn-primary btn-lg rounded-pill px-5 fw-bold shadow-sm"
                      style={{ transition: "0.3s" }}>
                      {status === "sending" ? "Sending..." : "Send Message →"}
                    </button>

                    {status === "success" && (
                      <p className="text-success mt-3">✅ Message sent successfully!</p>
                    )}
                    {status === "error" && (
                      <p className="text-danger mt-3">❌ Something went wrong. Please try again.</p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* ── Contact Info ────────────────────────── */}
          <div className="col-lg-4">
            <div className="card border-0 shadow-lg rounded-4 p-4 h-100" style={{ background: 'linear-gradient(135deg, var(--ftb-primary-dark) 0%, var(--ftb-bg-card) 100%)', color: '#fff', transition: 'var(--transition)' }}>

              <h3 className="fw-bold mb-4">Contact Information</h3>

              <div className="d-flex mb-4 gap-3">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px', flexShrink: 0 }}>
                  📍
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Our Office</h6>
                  <p className="small text-white-50 mb-0">
                    Office No. 3, S No. 846,<br />
                    Near Marathwada College,<br />
                    Shivajinagar, Maharashtra, India - 411 004.
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4 gap-3">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px', flexShrink: 0 }}>
                  ✉️
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Email Us</h6>
                  <p className="small text-white-50 mb-0">admin@ftbinnosphere.com</p>
                </div>
              </div>

              <div className="d-flex mb-5 gap-3">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px', flexShrink: 0 }}>
                  ⏰
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Working Hours</h6>
                  <p className="small text-white-50 mb-0">Mon - Fri: 9:00 AM - 6:00 PM</p>
                </div>
              </div>

              <div className="pt-4 border-top border-secondary">
                <h6 className="fw-bold mb-3">Follow Us</h6>
                <div className="d-flex gap-3">
                  <div className="bg-white bg-opacity-10 p-2 rounded-3" style={{ cursor: 'pointer' }}>🔗 LinkedIn</div>
                  <div className="bg-white bg-opacity-10 p-2 rounded-3" style={{ cursor: 'pointer' }}>🐦 Twitter</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
